export default __webpack_public_path__ + "static/media/shoes.04f8d65a.svg";